import {
    PRESUPUESTADOR_GET_ULTIMO_EDITADO_BEGIN,
    PRESUPUESTADOR_GET_ULTIMO_EDITADO_SUCCESS,
    PRESUPUESTADOR_GET_ULTIMO_EDITADO_FAILURE,
} from './constants'
import { Presupuestador as BFFPresupuestador } from '../../../common/BFF/BFF_presupuestador'
import { BFFAgent } from '../../../common/BFFAgent'
import { getLineasFinancieras } from '../redux/getLineasFinancieras'
import { validateSolicitudPendiente } from './validateSolicitudPendiente'
import { getPeritaje } from './getPeritaje/action'
import { PERITAJE_STATUS } from "../../../common/BFF/BFF_peritador/constants"
import { loadFileAssociations } from "../../common/redux/loadFileAssociations"
import { truncNumber } from 'common/utils/utils'
import { DEFAULT_CLIENT_BUSINESS_TYPE } from '../../clientes/constants'

export function getPresupuestoUltimoEditado() {
    return async (dispatch, getState) => {
        dispatch({
            type: PRESUPUESTADOR_GET_ULTIMO_EDITADO_BEGIN
        })
        const {
            common: {
                user: { id }
            }
        } = getState()

        let lastBudget = BFFPresupuestador.getPresupuestoUltimoEditado(id)

        const lineaFinancieraSelected = lastBudget.lineasFinancieras.find(linea => linea.id === lastBudget.selectedLineaFinanciera)
        let valor_tna = 0
        lastBudget.lineasFinancieras.forEach(linea => {
          if(linea.id === lastBudget.selectedLineaFinanciera) {
            linea.lines.forEach(line => {
              if(line.quantity === lastBudget.cuotasAfinanciar){
                valor_tna = line.tna
              }
            })
          }
        })

        let stock = null
        if(lastBudget.selectedStock){
            lastBudget.nuevo.Stocks.forEach(st=>{
            if(st.id === lastBudget.selectedStock){
              stock = st
            }
          })
        }
        
        let stock_color = stock?.idColor || null
        if(!stock_color && lastBudget.nuevo.nuevo === false && lastBudget.nuevo.colors.length === 1) {
            stock_color = lastBudget.nuevo.colors[0].id
        }
        let entregaUsado = null
        if(lastBudget.entregaUsados){
            entregaUsado = lastBudget.entregaUsados.map(usado => {
                return {...usado, license_plate: usado.patente, assessed: usado.peritado, take_improvement_amount: usado.take_improvement_amount || 0}
            })
        }
        
        const bonification = {
            ...lastBudget?.nuevo?.bonification,
            car_lot_amount: lastBudget?.nuevo?.bonification?.car_lot_sales_valid ? lastBudget?.nuevo?.bonification?.car_lot_amount: 0,
            especial_discount: lastBudget?.nuevo?.bonification?.discount_sales_valid ? lastBudget?.nuevo?.bonification?.discount_amount : 0
        }

        const catalog_id = lastBudget.catalog_id || lastBudget.nuevo.id
        const car_lot_id = lastBudget.car_lot_id || lastBudget.nuevo.car_lot_id

        const body = {
            marcaId: lastBudget.nuevo.brand_id,
            modeloID: lastBudget.nuevo.model_id,
            versionID: lastBudget.nuevo.version_id,
            car_lot_id: car_lot_id,
            nuevo: lastBudget.nuevo.nuevo,
            año: lastBudget.nuevo.anio,
            typeOfLine: "TASA",
            catalog_id: lastBudget.nuevo.id,
            tipoVenta: lastBudget?.tipoVentaSelected
        }
        let body_presupuesto = {
            is_reservation: lastBudget.is_reservation,
            is_nulled: lastBudget.is_nulled,
            branch_office_id: lastBudget.nuevo.branch_office_id,
            branch_office_name: lastBudget.nuevo.branch_office_name,
            car_lot_id: lastBudget.nuevo.car_lot_id,
            catalog_id: lastBudget.nuevo.id,
            catalog_marca: lastBudget.nuevo.brand,
            catalog_model: lastBudget.nuevo.model,
            catalog_version: lastBudget.nuevo.version,
            catalog_patente: lastBudget.nuevo.patente,
            catalog_anio: lastBudget.nuevo.año,
            catalog_price_list: lastBudget.nuevo.precio_lista,
            catalog_flete_alistaje: lastBudget.nuevo.flete_alistaje,
            catalog_bonificacion_fabrica: lastBudget.nuevo.bonificacion,
            catalog_accessory_1: lastBudget.nuevo.accessory_1,
            catalog_accessory_2: lastBudget.nuevo.accessory_2,
            catalog_net_sale_price: lastBudget.nuevo.net_sale_price,
            catalog_nuevo: lastBudget.nuevo.nuevo,
            client_id: lastBudget.cliente.id_cliente,
            client_id_lead: lastBudget.client_id_lead,
            client_first_name: lastBudget.cliente.nombre,
            client_last_name: lastBudget.cliente.apellido,
            client_doc_type: lastBudget.cliente.tipoDoc,
            client_doc: lastBudget.cliente.documento,
            client_email: lastBudget.cliente.email,
            client_telefono: lastBudget.cliente.telefono || null,
            client_pais: lastBudget.cliente.pais,
            client_provincia: lastBudget.cliente.provincia,
            sale_type: lastBudget.nuevo.nuevo ? lastBudget.tipoVentaSelected === "venta_directa" ? "DIRECTA" : "CONVENCIONAL" : "USADO",
            sale_quantity: lastBudget.sumarCantidad || 1,
            client_license_plate: lastBudget.client_license_plate,
            stock_id: lastBudget.selectedStock ? lastBudget.selectedStock : lastBudget.stock_id,
            stock_color,
            stock_ubicacion: stock ? stock.ubicacion : null,
            stock_vin: stock ? stock.vin : null,
            stock_sucursal: stock ? stock.sucursal : null,
            stock_estado: stock ? stock.estado : null,
            credit_line_id: lastBudget.selectedLineaFinanciera ? lastBudget.selectedLineaFinanciera : null,
            credit_line_name: lineaFinancieraSelected ? lineaFinancieraSelected.name : null,
            credit_line_banco: lineaFinancieraSelected ? lineaFinancieraSelected.bank : null,
            credit_line_cft: lastBudget.cft ? lastBudget.cft : 0,
            credit_line_tna: valor_tna || 0,
            credit_line_amount: lastBudget.montoAfinanciar ? lastBudget.montoAfinanciar : 0,
            amount_2b_financed: lastBudget.montoAfinanciar ? lastBudget.montoAfinanciar : 0,
            credit_line_fees: lastBudget.cuotasAfinanciar ? lastBudget.cuotasAfinanciar : 0,
            credit_line_first_quote_value: lastBudget.valorPrimeraCuota || 0,
            fees_number: lastBudget.cuotasAfinanciar ? lastBudget.cuotasAfinanciar : 0,
            monthly_avg_fee: lastBudget.cuotaProm,
            credit_line_avg_fees: lastBudget.cuotaProm ? Number(lastBudget.cuotaProm) : 0,
            delivery_costs: Math.trunc(lastBudget.costoPatentamiento) || 0,
            delivery_costs_modified: lastBudget.gastosDeEntregaModificados ? lastBudget.gastosDeEntregaModificados : null,
            credit_line_dcosts: lastBudget.gastosFinanciacion || 0,
            test_drive: lastBudget.test_drive,
            used_pr_percentage: 0,
            special_discount: lastBudget.special_discount || 0,
            Taking_cars: entregaUsado,
            Reserved_colors: lastBudget.reservedColors,
            observation: lastBudget.observation,
            factor_moneda_local: lastBudget.nuevo.totalSellValue,
            catalog_currencyName: lastBudget.nuevo.currencyName,
            catalog_foreign_currency_symbol: lastBudget.nuevo.foreingCurrencySymbol,
            catalog_currency_symbol: lastBudget.nuevo.currency_symbol,
            id_original_budget: lastBudget.id_original_budget || lastBudget.id,
            id_user_created: id,
            id_user_edit: id,
            Bonifications: bonification,
            car_lot_sales_valid: lastBudget.nuevo.bonification?.car_lot_sales_valid || 0,
            discount_sales_valid: lastBudget.nuevo.bonification?.discount_sales_valid || 0,
            taking_car_sales_valid: lastBudget.nuevo.bonification?.taking_car_sales_valid || 0,
            reservation_credits: JSON.stringify(lastBudget.lineasFinancieras),
            state: lastBudget.state,
            delivery_costs_original: truncNumber(lastBudget.costoPatentamientoOriginal),
          }

        let clientUpdated = null
        if (lastBudget.cliente.id_cliente) {
            const client = await BFFAgent.Clients.getCliente(lastBudget.cliente.id_cliente)
            clientUpdated = {
                apellido: client?.lastname,
                client_type: client?.client_type,
                client_business_type: client?.client_business_type || DEFAULT_CLIENT_BUSINESS_TYPE,
                cuil_cuit: client?.cuil_cuit,
                direccion: client?.address,
                documento: client?.document,
                email: client?.email,
                id_cliente: client?.id,
                localidad: client?.city,
                nombre: client?.firstname,
                pais: client?.country,
                provincia: client?.province,
                razon_social: client?.business_name,
                telefono: client?.phone,
                tipoDoc: client?.doctype,
                zip_code: client?.zip_code
            }
        }
        

        const catalogo = await BFFAgent.Catalogs.getCatalogId(catalog_id, car_lot_id)

        const totalSellValue = catalogo.multiplier * catalogo.actualSellValue

        dispatch(loadFileAssociations({ id: catalog_id, type: 'PRODUCTO' }))

        try {
          const alerts = await BFFPresupuestador.getAlertsUltimoPresupuestoEditado(body_presupuesto)
          const newBudget = {
            ...lastBudget,
            alerts,
            nuevo: {
                ...lastBudget.nuevo,
                ...catalogo,
                net_sale_price: catalogo.net_sale_price * totalSellValue,
                precio_lista: catalogo.precio_lista * totalSellValue,
                flete_alistaje: catalogo.flete_alistaje * totalSellValue,
                bonificacion: catalogo.bonificacion * totalSellValue,
            },
        }

        if(newBudget.nuevo.accessory_1) {
            newBudget.nuevo.accessory_1 *= totalSellValue
        }
        
        if(newBudget.nuevo.accessory_2) {
            newBudget.nuevo.accessory_1 *= totalSellValue
        }

        if(clientUpdated) {
            newBudget.cliente = clientUpdated
        }

        if(lastBudget.entregaUsados.length > 0){
            lastBudget.entregaUsados.forEach(usado => {
                dispatch(validateSolicitudPendiente(usado.patente, false, true, PERITAJE_STATUS.PERITAJE_PENDIENTE))
                dispatch(getPeritaje(usado, true, PERITAJE_STATUS.PERITAJE_FINALIZADO, false, usado.requestsId, true))
            })
          }
          dispatch({
              type: PRESUPUESTADOR_GET_ULTIMO_EDITADO_SUCCESS,
              data: newBudget
          })
          dispatch(getLineasFinancieras(body))
      } catch (err) {
          dispatch({
              type: PRESUPUESTADOR_GET_ULTIMO_EDITADO_FAILURE,
              data: { error: err }
          })
      }
    }
}

export function reducer(state, action) {
    switch (action.type) {
        case PRESUPUESTADOR_GET_ULTIMO_EDITADO_BEGIN:
            return {
                ...state,
                entregaUsados: [],
                loadItemNuevoPending: true
            }
        case PRESUPUESTADOR_GET_ULTIMO_EDITADO_SUCCESS:
            return {
                ...state,
                ...action.data,
                loadItemNuevoPending: false
            }

        default:
            return state
    }
}
